<!--
 * @Author: 范向玲
 * @Date: 2022-10-08 16:16:00
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @LastEditTime: 2024-12-25 15:40:51
 * @Description: 数据审核
 * @FilePath: \web\src\components\DataManagement\audit\index.vue
-->
<template>
  <div class="data-management-audit">
    <div class="search-container">
      <SearchModule @submit="searchHandle" storeModule="dataAudit">
        <template v-slot:select>
          <!-- S 审核状态 -->
          <div class="search-item">
            <a-select class="project-rate" placeholder="审核状态" v-model:value="requestParams.status"
              :getPopupContainer="(triggerNode) => triggerNode.parentNode">
              <a-select-option v-for="item in projectStatus" :key="item.key">
                {{ item.name }}
              </a-select-option>
              <template #suffixIcon>
                <CaretDownOutlined />
              </template>
            </a-select>
          </div>
          <!-- E 审核状态 -->
          <!-- S 提交类型 -->
          <div class="search-item">
            <a-select class="project-rate" placeholder="提交类型" v-model:value="requestParams.type"
              :getPopupContainer="(triggerNode) => triggerNode.parentNode">
              <a-select-option v-for="item in projectType" :key="item.key">
                {{ item.name }}
              </a-select-option>
              <template #suffixIcon>
                <CaretDownOutlined />
              </template>
            </a-select>
          </div>
          <!-- E 提交类型 -->
        </template>
      </SearchModule>

      <div class="crud-wrapper">
        <div v-for="(item, index) in operationBtns.filter((i) => i.operation.includes(config.getPermissionId()))"
          :key="index" v-bind="item.option" :class="selectedKeys.length > 0 ? 'crud-item-abled' : 'crud-item-disabled'"
          @click="item.click">
          {{ item.name }}
        </div>
      </div>
    </div>

    <a-table rowKey="sn" class="management-table" :dataSource="industryPages" :loading="industryPagesLoading"
      :columns="columns" @change="changePage" :row-selection="rowSelection" :scroll="{ y: '90%' }"
      :pagination="paginationOption">
      <template #serial="{ index }">{{ index + 1 }}</template>

      <template #primaryCommodity="{ record }">
        <img class="primary-commodity-img" :src="getMineralImage(record)" alt="" srcset="" />
      </template>

      <!-- 信息情况 -->
      <template #status="{ record }">
        <span>{{ getProjectStatus(record.status) }}</span>
      </template>

      <!-- 提交类型 -->
      <template #type="{ record }">
        <span>{{ getProjectType(record.type) }}</span>
      </template>

      <!-- 全部矿种 -->
      <template #commoditiesList="{ text: commoditiesList }">
        <span>
          <a-tag v-for="(item, index) in commoditiesList ? commoditiesList.split(',') : []" :key="index">{{
            item
          }}</a-tag>
        </span>
      </template>

      <!-- 操作  -->
      <template #action="{ record }">
        <section class="action-icons">
          <i v-for="(item, index) in tableOperationListConf.filter(
            (i) => i.operation.includes(config.getPermissionId()) && i.status.includes(record.status),
          )" :key="index" v-bind="item.option" @click="item.click(record)">
          </i>
        </section>
      </template>
    </a-table>

    <Modal :option="confirmModalConf" @confirm="confirm" @close="close">
      <template v-slot:main>
        <a-textarea v-if="confirmModalConf.showRemark" v-model:value="confirmModalConf.remark" placeholder="请填写备注"
          :rows="8" />
        <section class="integral-warp">
          <!-- <section>确认是否通过项目审核？</section> -->
          <a-radio-group v-model:value="confirmModalConf.isPass" class="type-radio-group" style="color:#fff">
            <a-radio value="2" style="color:#fff">否</a-radio>
            <a-radio value="1" style="color:#fff">是</a-radio>
          </a-radio-group>
          <section v-if="confirmModalConf.isPass === '1'">
            <section>请赋予用户积分等级：</section>
            <a-radio-group v-model:value="confirmModalConf.integral" class="type-radio-group">
              <a-radio :value="item.value" v-for="item in scoreList" :key="item.value" style="color:#fff">{{ item.name
                }}</a-radio>
            </a-radio-group>
          </section>
        </section>
      </template>
    </Modal>
    <!-- / 操作弹出框 -->

    <PopupModal :option="modalOption" v-if="modalOption.visible" :loading="modalOption.loading"
      :dataList="modalOption.datalist" :modalType="modalOption.modalType" :modalContrast='modalContrast'
      routeType="audit" @search="searchHandle" />
    <!-- / 新增编辑弹窗 -->
  </div>
</template>

<script setup>
import { ref, reactive, computed, toRefs, onBeforeMount, } from 'vue';
import { useStore, } from 'vuex';
import Modal from '@/components/lib/Modal/modal1.vue';
import PopupModal from '@/components/lib/Modal/modal.vue';
import { GET_MANAGEMENT_INDUSTRY_PAGE, } from '@/store/modules/actions/dataAudit';
import { getInfoAllApi, } from '@/api/projectLibrary/projectLibraryApi';
import { getMineralImage, getProjectStatus, getProjectType, } from '@/components/utils/utils';
import { setOperationCheckApi, } from '@/api/dataManagement/dataAudit';
import { CaretDownOutlined, } from '@ant-design/icons-vue';
import config from '@/config/config';
import SearchModule from '../component/search.vue';
import tableConfig from './tableConfig.js';

const columns = tableConfig;

const { state, dispatch: storeDispatch, commit: storeCommit, } = useStore();
// state
const dataAuditState = computed(() => state.dataAudit);
const { requestParams, industryPages, totalCount, industryPagesLoading, projectStatus,
  projectType, } = toRefs(dataAuditState.value);
// 重写commit
const commit = (space, methods, params) => storeCommit(`${space || 'dataAudit'}/${methods}`, params);
// 重写dispatch
const dispatch = (space, methods, params) => storeDispatch(`${space || 'dataAudit'}/${methods}`, params);

const selectedKeys = ref([]); // 表格选中id
const modalContrast = ref(false); //是否需要对比
const scoreList = [
  { name: '1分', value: '1', },
  { name: '3分', value: '3', },
  { name: '5分', value: '5', },
];
const paginationOption = computed(() => ({
  total: totalCount.value,
  pageSize: requestParams.value.size,
  current: requestParams.value.page,
  showSizeChanger: true,
  showQuickJumper: true,
  pageSizeOptions: ['6', '10', '20', '30', '40', '50',],
}));

// 确认弹窗 公用
const confirmModalConf = reactive({
  loading: false,
  visible: false,
  title: '',
  confirm: null,
  remark: '',
  callback: null,
  showRemark: true,
  isPass: null,
  integral: null,
});

// 新增编辑弹窗 公用
const modalOption = reactive({
  visible: false,
  loading: false,
  datalist: {},
  modalType: 'default',
});

/**
 * @description 表格选中事件
 */
const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {
    selectedKeys.value = selectedRows;
  },

  getCheckboxProps: (record) => {
    return {
      disabled: record.status !== 0, // Column configuration not to be checked
    };
  },
};

const setDataList = (arr, sn) => {
  let datalist = {
    propInfoEntity: {},
    projectGeoInfoEntity: {},
    projectGeologyInfoEntity: {},
    projectProductEntity: {},
    projectResourceInfoEntityList: [],
    projectStockInfoEntity: {},
  };
  const len = arr.propInfoEntity.length;
  const idx = arr.propInfoEntity.findIndex((item) => sn === item.sn);

  if (len === 1 || idx === len - 1) {
    const resourceInfoEntityList = arr.projectResourceInfoEntityList.filter((item) => sn === item.sn);

    modalContrast.value = false;
    datalist.propInfoEntity = arr.propInfoEntity[idx];
    datalist.projectGeoInfoEntity = arr.projectGeoInfoEntity[idx];
    datalist.projectGeologyInfoEntity = arr.projectGeologyInfoEntity[idx];
    datalist.projectProductEntity = arr.projectProductEntity[idx];
    datalist.projectResourceInfoEntityList = resourceInfoEntityList;
    datalist.projectStockInfoEntity = arr.projectStockInfoEntity[idx];
  } else {
    modalContrast.value = true;
    const num = arr.projectResourceInfoEntityList.length / len;
    const list = arr.projectResourceInfoEntityList.findIndex((item) => sn === item.sn);

    let newData = arr.projectResourceInfoEntityList.slice(list, list + num);

    let oldData = arr.projectResourceInfoEntityList.slice(list + num, list + num + num);

    datalist = [{
      propInfoEntity: arr.propInfoEntity[idx],
      projectGeoInfoEntity: arr.projectGeoInfoEntity[idx],
      projectGeologyInfoEntity: arr.projectGeologyInfoEntity[idx],
      projectProductEntity: arr.projectProductEntity[idx],
      projectResourceInfoEntityList: newData,
      projectStockInfoEntity: arr.projectStockInfoEntity[idx],
    }, {
      propInfoEntity: arr.propInfoEntity[idx + 1],
      projectGeoInfoEntity: arr.projectGeoInfoEntity[idx + 1],
      projectGeologyInfoEntity: arr.projectGeologyInfoEntity[idx + 1],
      projectProductEntity: arr.projectProductEntity[idx + 1],
      projectResourceInfoEntityList: oldData,
      projectStockInfoEntity: arr.projectStockInfoEntity[idx + 1],
    },];
  }

  modalOption.loading = false;
  modalOption.datalist = datalist;
};
/**
 * @description 单行数据详情跳转
 */
const detailRecord = (record) => {
  const { id, sn, } = record;

  modalOption.modalType = 'default';
  modalOption.loading = true;

  // getInfoAllApi(id, { params: { sn: sn, },})
  getInfoAllApi(id, { params: { sn: 'all', }, })
    .then((d) => {
      setDataList(d, sn);

    })
    .catch(() => {
      modalOption.visible = false;
    });
  modalOption.visible = true;
};

/**
 * @description 查询
 */
const searchHandle = () => {
  dispatch(null, GET_MANAGEMENT_INDUSTRY_PAGE);
};

/**
 * @description 页码change事件
 */
const changePage = (page) => {
  commit(null, 'setRequestParams', { page: page.current, size: page.pageSize, });
  searchHandle();
};

/**
 * @description 关闭通用弹窗
 */
const close = () => {
  confirmModalConf.remark = '';
  confirmModalConf.visible = false;
  confirmModalConf.isPass = null;
  confirmModalConf.integral = null;
};

/**
 * @description 确认通用弹窗
 */
const confirm = () => {
  confirmModalConf.callback();
};

/**
 * @description 审核通过
 */
const adoptProject = (ids = []) => {
  // debugger;
  // console.warn(ids);
  ids.forEach((item, index) => {
    const { sn, id, } = item;
    const requestData = { sn, id, status: confirmModalConf.isPass, integral: confirmModalConf.integral, };

    setOperationCheckApi(requestData).then((res) => {
      if (index === ids.length - 1) {
        confirmModalConf.visible = false;
        confirmModalConf.isPass = '2';
        confirmModalConf.integral = null;
        searchHandle();
      }
    });
  });
};

/**
 * @description 审核通过项目之前
 */
const beforeAdoptProject = (ids) => {
  confirmModalConf.showRemark = false;
  confirmModalConf.title = '确认通过项目审核？';
  confirmModalConf.isPass = '2';
  confirmModalConf.callback = () => adoptProject(ids);
  confirmModalConf.visible = true;
};

/**
 * @description 单行数据审核通过
 */
const adoptRecord = (record) => {
  const { id, sn, } = record;

  beforeAdoptProject([{ id, sn, },]);
};

/**
 * @description 勾选通过
 */
const selectAdoptProject = () => {
  const ids = selectedKeys.value;

  beforeAdoptProject(ids);
};

/**
 * @description 审核不通过
 */
const refuseProject = (ids) => {
  ids.forEach((item, index) => {
    const { sn, id, } = item;
    const requestData = { sn, id, status: 2, };

    setOperationCheckApi(requestData).then((res) => {
      if (index === ids.length - 1) {
        confirmModalConf.visible = false;
        searchHandle();
      }
    });
  });
  // removeProjectApi([ids,]).then((res) => {
  //   confirmModalConf.visible = false;
  //   searchHandle();
  // });
};

/**
 * @description 审核不通过项目之前
 */
const beforeRefuseProject = (ids) => {
  confirmModalConf.showRemark = true;
  confirmModalConf.title = '确认不通过项目审核？';
  confirmModalConf.callback = () => refuseProject(ids);
  confirmModalConf.visible = true;
};

/**
 * @description 单行数据审核不通过
 */
const refuseRecord = (record) => {
  const { id, sn, } = record;

  beforeRefuseProject([{ id, sn, },]);
};

/**
 * @description 勾选不通过
 */
const selectRefuseProject = () => {
  const ids = selectedKeys.value;

  beforeRefuseProject(ids);
};

// 操作的权限
const tableOperationListConf = [
  {
    option: {
      style: 'color: rgb(255, 200, 120)',
      class: 'iconfont icon-gengduo',
      title: '详情',
    },
    click: detailRecord,
    operation: [1, 2, 3,],
    status: [0, 1, 2, 3,],
  },
  {
    option: {
      style: 'color: rgb(255, 200, 120)',
      class: 'iconfont icon-duihao',
      title: '通过',
    },
    click: adoptRecord,
    operation: [1,],
    status: [0,],
  },
  {
    option: {
      style: 'color: rgb(255, 200, 120)',
      class: 'iconfont icon-weibiaoti522',
      title: '不通过',
    },
    click: refuseRecord,
    operation: [1,],
    status: [0,],
  },
];

// 编辑按钮权限
const operationBtns = [
  {
    option: {
      class: 'crud-item',
      title: '通过',
    },
    name: '通过',
    click: selectAdoptProject,
    operation: [1,],
  },
  {
    option: {
      class: 'crud-item',
      title: '不通过',
    },
    name: '不通过',
    click: selectRefuseProject,
    operation: [1,],
  },
];

onBeforeMount(() => {
  searchHandle();
});
</script>

<style lang="scss">
.data-management-audit {
  height: 100%;
  background: rgba(179, 150, 92, 0.05);

  /* 检索条件 */
  .search-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: .1rem;
    height: 0.5rem;
    margin-bottom: 0.1rem;

    .crud-wrapper {
      display: flex;
      height: 0.51rem;
      padding: 0.13rem 0.1rem;

      .crud-item {
        margin-right: 0.04rem;
        width: 0.5rem;
        color: #fff;
        // background-color: #efb227;
        background-image: url(~@/static/images/dataManagement/curd_btn.png);
        background-size: 100% 100%;
        text-align: center;
      }

      .crud-item:hover {
        cursor: pointer;
      }

      .crud-item-disabled {
        pointer-events: none;
        color: rgba(255, 255, 255, 0.6);
        // background-color: rgba(239, 178, 39, 0.6);
        opacity: 0.8;
      }

      .crud-item-disabled:hover {
        cursor: no-drop;
      }
    }
  }

  /* 矿种图标 */
  .minerals-img {
    width: 0.6rem;
    height: 0.3rem;
  }


  /* 表格样式 */
  .management-table {
    height: calc(100% - 0.5rem);

    .ant-spin-container {
      display: flex;
      flex-direction: column;
      align-items: end;
    }

    .ant-spin-nested-loading,
    .ant-spin-container,
    .ant-table-content {
      height: 100%;
    }

    .ant-table {
      height: calc(100% - .70rem);
      background: none;
      padding-left: 0.1rem;

      .ant-table-scroll {
        height: 100%;
        overflow: visible;
        overflow-x: visible;

        .ant-table-header {
          overflow: visible !important;
            margin-bottom:0 !important;
        }
      }

      .ant-table-header {
        background: none;
      }

      .ant-table-body {
        overflow-x: hidden !important;
        overflow-y: auto !important;
        background: none;
      }

      /* 矿种 */
      .primary-commodity-img {
        width: 0.8rem;
        height: 0.6rem;
      }

      /* 图标 */
      .action-icons {
        i {
          font-size: 0.22rem;
          margin-right: 0.04rem;
          cursor: pointer;
        }
      }

      .ant-table-thead {
        border: .01rem solid #4d3f1c;
        border-radius: .10rem .10rem 0rem 0rem;
        background: none;
      }

      .ant-table-thead>tr>th {
        color: #dccdab;
        background: rgba(179, 150, 92, 0.2);
        border: none;
      }

      .ant-table-tbody>tr>td {
        background-color: transparent;
        color: #fff;
        border-bottom: .01rem solid rgba(179, 150, 92, 1);
        vertical-align: middle;

        .ant-checkbox-disabled .ant-checkbox-inner {
          background-color: #7f7e7e;
          border-color: #7f7e7e !important;
        }
      }

      .ant-table-placeholder {
        height: 100%;
        background-color: rgba(77, 63, 28, 1);
        border-top: rgba(179, 150, 92, 1);
        border-bottom: rgba(179, 150, 92, 1);
      }

      .ant-empty-normal {
        color: rgba(179, 150, 92, 1);
      }

      // 暂无数据填充样式
      // .ant-empty-img-simple-path {
      //   fill: rgba(77, 63, 28, 1);
      // }
      // .ant-empty-img-simple-ellipse {
      //   fill: rgba(77, 63, 28, 1);
      // }
      .ant-table-thead>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-tbody>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-thead>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
        background-color: rgba(179, 150, 92, 0.6);
      }

      .ant-table-thead>tr:hover.ant-table-row-selected>td,
      .ant-table-tbody>tr:hover.ant-table-row-selected>td {
        background-color: rgba(179, 150, 92, 0.6);
      }

      .ant-table-tbody>tr.ant-table-row-selected td {
        background-color: rgba(77, 63, 28, 1);
        color: #fff;
      }
    }
  }

  // .integral-warp {
  /* 单选组件 */
  .type-radio-group {
    .ant-radio-wrapper {
      color: #fff;
      margin-left: 0;
      margin: .1rem 0;
    }
  }

  // }
}
</style>
